<template>
  <Modal v-model="isShow" width="65%" :closable="false" :mask-closable="false">
    <div slot="header" class="info-header">
      <div class="ivu-modal-header-inner">客户账单上传信息</div>
      <a class="ivu-modal-close" @click="closeModel"><i class="ivu-icon ivu-icon-ios-close"></i></a>
    </div>
    <div>
      <Form ref="tradeuploadForm" :model="form" :label-width="80" :rules="ruleValidate">
        <Row>
          <Col span="8">
            <FormItem label="ID" prop="id">
              <Input v-model="form.id" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="客户id" prop="customId">
              <Input v-model="form.customId" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="上传订单号" prop="tradeNo">
              <Input v-model="form.tradeNo" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="解压码" prop="decpCode">
              <Input v-model="form.decpCode" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="账单类型" prop="biilType">
              <Input v-model="form.biilType" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="银行卡号" prop="bankCardNo">
              <Input v-model="form.bankCardNo" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="上传时间" prop="uploadTime">
              <Input v-model="form.uploadTime" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="账单开始时间" prop="startTime">
              <Input v-model="form.startTime" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="账单结束时间" prop="endTime">
              <Input v-model="form.endTime" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="创建用户Id" prop="crtUserId">
              <Input v-model="form.crtUserId" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="创建时间" prop="crtTime">
              <Input v-model="form.crtTime" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="修改人" prop="mdfUserId">
              <Input v-model="form.mdfUserId" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="修改时间" prop="mdfTime">
              <Input v-model="form.mdfTime" :disabled="disable"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
    <div slot="footer">
      <Button @click="closeModel">取消</Button>
      <Button type="primary" @click="submit"  v-show="!disable">提交</Button>
    </div>
  </Modal>
</template>

<script>

export default {
  name: 'tradeupload-info',
  data () {
    return {
      form: {},
      isShow: false,
      type: 'add',
      disable: false,
      ruleValidate: {
        id: [
          { required: true, message: 'ID不允许为空', trigger: 'blur' }
        ],
        customId: [
          { required: true, message: '客户id不允许为空', trigger: 'blur' }
        ],
        tradeNo: [
          { required: true, message: '上传订单号不允许为空', trigger: 'blur' }
        ],
        decpCode: [
          { required: true, message: '解压码不允许为空', trigger: 'blur' }
        ],
        biilType: [
          { required: true, message: '账单类型不允许为空', trigger: 'blur' }
        ],
        bankCardNo: [
          { required: true, message: '银行卡号不允许为空', trigger: 'blur' }
        ],
        uploadTime: [
          { required: true, message: '上传时间不允许为空', trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '账单开始时间不允许为空', trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '账单结束时间不允许为空', trigger: 'blur' }
        ],
        crtUserId: [
          { required: true, message: '创建用户Id不允许为空', trigger: 'blur' }
        ],
        crtTime: [
          { required: true, message: '创建时间不允许为空', trigger: 'blur' }
        ],
        mdfUserId: [
          { required: true, message: '修改人不允许为空', trigger: 'blur' }
        ],
        mdfTime: [
          { required: true, message: '修改时间不允许为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    openModel (type, data) {
      this.isShow = true
      this.type = type
      if (data) {
        this.form = data
      } else {
        this.form = {}
      }
      this.disable = type === 'detail'
    },
    closeModel () {
      this.isShow = false
    },
    submit () {
      this.$refs.tradeuploadForm.validate((valid) => {
        if (valid) {
          switch (this.type) {
            case 'create':
              this.C('tradeupload', this.form).then(data => {
                this.isShow = false
                this.$emit('handle-search')
              })
              break
            case 'update':
              this.U('tradeupload', this.form).then(data => {
                this.isShow = false
                this.$emit('handle-search')
              })
              break
          }
        } else {
          this.$Message.error('请检查填写的数据')
        }
      })
    }
  },
  mounted: function () {
  }
}
</script>
